import { FC, memo } from 'react'
import { DropTargetMonitor, useDrop } from 'react-dnd'

export interface TargetBoxProps {
  canDrop?: Function
  onDrop: (item: any) => void
  types: string[]
  children: React.ReactNode
}

export const TargetBox: FC<TargetBoxProps> = memo(function TargetBox({ canDrop, onDrop, children, types }) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: types,
      drop(_item: any) {
        if (canDrop && !canDrop(_item)) return undefined
        onDrop(_item)
        return undefined
      },
      collect: (monitor: DropTargetMonitor) => ({
        isOver: monitor.isOver() && (!canDrop || canDrop(monitor.getItem())),
        canDrop: monitor.canDrop(),
      }),
    }),
    [onDrop],
  )

  return (
    <div
      ref={drop}
      className={isOver ? 'outline-[5px] outline-red-400 outline-dashed z-9 relative' : ''}
      role="TargetBox"
    >
      {children}
    </div>
  )
})
